import { apiClient } from "../axios/apiClient";

export interface ContactMessagePayload {
  name: string;
  email: string;
  message: string;
  /** A hidden field real visitors never fill in; the API treats anything in it as a bot. */
  website: string;
}

export const contactService = {
  create: (payload: ContactMessagePayload): Promise<void> =>
    apiClient.post("/contact", payload).then(() => undefined),
};
